<template>
	<div
		class="g-pay-media-pay"
		:class="{ 'g-pay-media-pay--h5': h5 }"
		 v-if="!isUnlocked && !shouldHidePrice"
	>
		<div v-if="showInfoBar && infoText" class="g-pay-media-pay__info">
			<SoundOutlined class="g-pay-media-pay__info-icon" />
			<span v-html="infoText"></span>
		</div>
		<div class="g-pay-media-pay__main">
			<div class="g-pay-media-pay__price-box">
				<div class="g-pay-media-pay__price">
					<span class="g-pay-media-pay__currency">{{ currency }}</span>
					<span class="g-pay-media-pay__price-value">{{ price }}</span>
				</div>
				<div v-if="payDesc" class="g-pay-media-pay__desc">{{ payDesc }}</div>
			</div>
			<button
				type="button"
				class="g-pay-media-pay__unlock-btn"
				:style="{ background: buttonBg }"
				@click.stop="$emit('unlock')"
			>
				<i class="mbm-iconfont mbm-suoding" aria-hidden="true"></i>
				<span>{{ buttonText }}</span>
			</button>
		</div>
	</div>
</template>

<script>
	import { SoundOutlined } from '@ant-design/icons-vue';

	export default {
		name: 'GPayMediaPaySection',
		components: { SoundOutlined },
		inject: {
			geditPay: {
				default: null,
			},
		},
		props: {
			currency: { type: String, default: '¥' },
			price: { type: [String, Number], default: '9.90' },
			buttonText: { type: String, default: '立即解锁' },
			buttonBg: { type: String, default: '#285af9' },
			payDesc: { type: String, default: '' },
			showInfoBar: { type: Boolean, default: true },
			infoText: { type: String, default: '' },
			isUnlocked: { type: Boolean, default: false },
			h5: { type: Boolean, default: false },
		},
		emits: ['unlock'],
		computed: {
			shouldHidePrice() {
				return this.geditPay?.shouldHideOtherPrices === true;
			},
		},
	};
</script>

<style scoped lang="less">
	.g-pay-media-pay {
		padding:0 14px 14px;
		border-radius: 12px;
	}

	.g-pay-media-pay__info {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 12px;
		border-radius: 10px;
		background: #eef4ff;
		font-size: 12px;
		color: #666;
		line-height: 1.5;

		:deep(strong) {
			color: #285af9;
			font-weight: 600;
		}
	}
	.g-pay-media-pay--h5{
		padding:0 0.28rem 0.28rem;
		border-radius: 0.24rem;
	}
	.g-pay-media-pay__info-icon {
		flex-shrink: 0;
		font-size: 14px;
		color: #285af9;
	}

	.g-pay-media-pay__main {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		margin-top: 12px;
	}

	.g-pay-media-pay__price {
		display: flex;
		align-items: baseline;
		color: #ff4d4f;
		line-height: 1;
	}

	.g-pay-media-pay__currency {
		font-size: 14px;
		font-weight: 600;
		margin-right: 2px;
	}

	.g-pay-media-pay__price-value {
		font-size: 28px;
		font-weight: 700;
	}

	.g-pay-media-pay__desc {
		margin-top: 6px;
		font-size: 12px;
		color: #999;
		line-height: 1.4;
	}

	.g-pay-media-pay__unlock-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		flex-shrink: 0;
		border: none;
		border-radius: 999px;
		padding: 10px 16px;
		font-size: 13px;
		font-weight: 600;
		color: #fff;
		cursor: pointer;
		line-height: 1.2;
		white-space: nowrap;

		.mbm-iconfont {
			font-size: 15px;
		}
	}

	.g-pay-media-pay--h5 {
		.g-pay-media-pay__unlock-btn {
			.mbm-iconfont {
				font-size: 0.3rem;
			}
		}
	}
</style>
